import PageList from '#/modules/commonComponents/PageList';
import documentMgmtNavigate from '#/modules/infra/navigation/documentMgmtNavigate';

const DocumentMgmtHubPage = () => (
  <PageList title="單據管理" linkList={documentMgmtNavigate} />
);

export default DocumentMgmtHubPage;
